import { createFileRoute } from "@tanstack/react-router";

import { ReturnsPage } from "../../../features/orders/returns-page";

export const Route = createFileRoute("/_app/orders/returns")({ component: ReturnsPage });
